import { Injectable } from '@angular/core';
import { Observable, of, shareReplay, tap } from 'rxjs';
import { ISingleResponseApiModel } from '../../../../core/models/base-api-general.model';
import { ProductCategoryEnum } from '../constants/product.constant';
import { ProductService } from './api/product.service';

@Injectable({ providedIn: 'root' })
export class UsedCategoryService {
    private categoriesToShow?: ISingleResponseApiModel<ProductCategoryEnum[]>;
    private categoriesToShow$?: Observable<ISingleResponseApiModel<ProductCategoryEnum[]>>;

    constructor(private productService: ProductService) {}

    getUsedCategories(): Observable<ISingleResponseApiModel<ProductCategoryEnum[]>> {
        if (this.categoriesToShow) {
            return of(this.categoriesToShow);
        }

        if (!this.categoriesToShow$) {
            this.categoriesToShow$ = this.productService.getUsedCategories().pipe(
                tap((response) => (this.categoriesToShow = response)),
                shareReplay(1),
            );
        }

        return this.categoriesToShow$;
    }
}
